import React, { Component } from 'react';
import { Link } from 'react-scroll';
import LOGOwhite from '../../static/logo-white.svg';
import './_header.scss';


const qs = require('qs');

class Header extends Component {
  constructor(props) {
    super(props);
    this.toggleClass = this.toggleClass.bind(this);
    this.handleSetActive = this.handleSetActive.bind(this);
    this.toggleBut = this.toggleBut.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      menuActive: false,
      buttonActive: false,
      formActive: false,
      firstname: '',
      email: '',
      message: 'Message receive',
      type: 'initial',
      sending: false,
      message: '',
    };
  }

  componentDidMount() {
    // When the component is mounted, add your DOM listener to the "nv" elem.
    // (The "nv" elem is assigned in the render function.)
    const element = document.getElementById('getSolutions');
    element.addEventListener('click', this.toggleBut);
  }

  componentWillUnmount() {
    // Make sure to remove the DOM listener when the component is unmounted.
    const element = document.getElementById('getSolutions');
    element.removeEventListener('click', this.toggleBut);
  }

  toggleClass() {
    const currentState = this.state.menuActive;
    this.setState({ menuActive: !currentState });
  }

  toggleBut() {
    const currentState = this.state.formActive;
    this.setState({ formActive: !currentState, message: '' });

    if (!this.state.formActive) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }

  handleSetActive(name, other) {
    const targetName = document.getElementsByClassName(name);
    // console.log('name: ', name, 'clicked: ', targetName, 'prev element: ', targetName["0"].previousElementSibling);
    targetName['0'].classList.add('active');
    if (targetName['0'].previousElementSibling) {
      targetName['0'].previousElementSibling.classList.remove('active');
    }

    if (name === 'features') {
      this.setState({ buttonActive: false });
    } else {
      this.setState({ buttonActive: true });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ status: 'Sending... ', sending: true });

    const data = {
      form_name: this.state.firstname,
      form_email: this.state.email,
      form_msg: this.state.message,
    };

    const dataForm = new FormData();
    dataForm.append('form_name', this.state.firstname);
    dataForm.append('form_email', this.state.email);
    dataForm.append('form_msg', this.state.message);

   // console.log('form data: ', data);

    for (const key of dataForm.entries()) {
   //   console.log(`${key[0]}, ${key[1]}`);
    }


    fetch('mail.php', {
      method: 'POST',
      headers: { 'Content-type': 'application/x-www-form-urlencoded' },
      body: qs.stringify(data),
    }).then(jsonData => JSON.stringify(jsonData)).then((jsonStr) => {
      this.setState({ status: 'Your Message has been sent, we will contact you as soon as possible to schedule a meeting.', sending: false });

    //  console.log(jsonStr);
    });
  }


  render() {
    const serviceList = this.props.data[0].list.split(',');
    const formLabels = this.props.data[1].content.split(',');

    const items3 = serviceList.slice(0, 3).map(item => <li key={`key-${item}`}>{item}</li>);

    const items6 = serviceList.slice(4, 7).map(item => <li key={`key-${item}`}>{item}</li>);

    const items9 = serviceList.slice(8, 15).map(item => <li key={`key-${item}`}>{item}</li>);

    return (
      <div className="top-wrapper">
        <div className={this.state.formActive ? 'top-wrapper-modal active' : 'top-wrapper-modal'}>
          <div className="modal">
            <button className="close-modal" onClick={this.toggleBut}>
              <i className="fas fa-times" />
            </button>
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <h2>{this.props.data[0].title}</h2>
                  <p className="lead">{this.props.data[0].content}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <ul>
                    {items3}
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul>
                    {items6}
                  </ul>
                </div>
                <div className="col-md-4">
                  <ul>
                    {items9}
                  </ul>
                </div>
              </div>
              <div className="row">
                <div className="col-12">

                  <form method="POST" action="mail.php" onSubmit={this.handleSubmit} className={this.state.sending ? 'lead-form active' : 'lead-form'}>
                    <p>{this.props.data[1].title}</p>
                    <input type="text" placeholder={formLabels[0]} id="form_name" value={this.state.firstname} onChange={ev => this.setState({ firstname: ev.target.value })} disabled={this.state.sending} required />
                    <input type="email" placeholder={formLabels[1]} id="form_email" value={this.state.email} onChange={ev => this.setState({ email: ev.target.value })} disabled={this.state.sending} required />
                    <textarea rows="4" placeholder={formLabels[2]} id="form_msg" value={this.state.message} onChange={ev => this.setState({ message: ev.target.value })} disabled={this.state.sending} required />

                    <p className="status">{this.state.status}</p>

                    <button type="submit" className="btn" disabled={this.state.sending}>{this.props.data[1].link}</button>


                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <header className="header">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="header-content">
                  <span className="header-logo">
										Squidsource
                  </span>
                  <a href={`/${this.props.langu}`} className="langswich">{this.props.langu}</a>
                  <button className={this.state.buttonActive ? 'btn call-to-action active' : 'btn call-to-action'} onClick={this.toggleBut}><i className="far fa-caret-square-down" /><span>{this.props.data[2].title}</span></button>

                  <button className={this.state.menuActive ? 'header-menu-toggle active' : 'header-menu-toggle'} onClick={this.toggleClass}>
                    <i className="fas fa-bars" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={this.state.menuActive ? 'menu-fixed active' : 'menu-fixed'}>

            <Link href="#features" activeClass="active" to="features" spy smooth duration={500} offset={-120} className="menu-fixed-item features" isDynamic onSetActive={this.handleSetActive}>
              <img src={LOGOwhite} />
            </Link>


            <Link href="#about" activeClass="active" to="about" spy smooth offset={350} duration={400} hashSpy className="menu-fixed-item about" isDynamic onSetActive={this.handleSetActive}>
              {this.props.data[3].title}
            </Link>

            <Link href="#portfolio" activeClass="active" to="portfolio" spy smooth offset={300} duration={400} hashSpy onSetActive={this.handleSetActive} className="menu-fixed-item portfolio" isDynamic>
              {this.props.data[4].title}
            </Link>

            <Link href="#whyus" activeClass="active" to="whyus" spy smooth offset={300} duration={400} hashSpy onSetActive={this.handleSetActive} className="menu-fixed-item whyus" isDynamic>
              {this.props.data[5].title}
            </Link>

          </div>
          <div className={this.state.menuActive ? 'menu-fixed mobile active' : 'menu-fixed mobile'}>

            <Link href="#features" activeClass="active" to="features" spy smooth duration={500} offset={-120} className="menu-fixed-item features" isDynamic >
              <img src={LOGOwhite} />
            </Link>


            <Link href="#about" activeClass="active" to="about" spy smooth offset={0} duration={500} hashSpy className="menu-fixed-item about" isDynamic >
              {this.props.data[3].title}
            </Link>

            <Link href="#portfolio" activeClass="active" to="portfolio" spy smooth offset={0} duration={400} hashSpy className="menu-fixed-item portfolio" isDynamic>
              {this.props.data[4].title}
            </Link>

            <Link href="#whyus" activeClass="active" to="whyus" spy smooth offset={0} duration={400} hashSpy className="menu-fixed-item whyus" isDynamic>
              {this.props.data[5].title}
            </Link>

          </div>


        </header>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js